import Vue from 'vue';
import Vuex from 'vuex';
import { urls } from '@js'

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		// 登录状态
		loginStatus: {},
		init_state: 0,//个人信息页，初始化解锁状态
		acDownloadUrl: null,
		per_opt: [{
			names: "Basic Information",
			addClass: "step1",
			to: '/personal_profile/personal_in',
			step: 'info'
		}, {
			names: "Qualifications",
			addClass: "step2",
			to: '/personal_profile/personal_qa',
			step: 'qualific'
		}, {
			names: 'Payment Method',
			addClass: "step3",
			to: '/personal_profile/payment',
			step: 'paymode'
		}, {
			names: 'Introductory audio',
			addClass: "step4",
			to: '/personal_profile/on_board',
			step: 'video'
		}, {
			names: 'Sign SA',
			addClass: "step5",
			to: '/personal_profile/sign_sa',
			step: 'sa'
		}],
		pop_up: false,//ntt interview的reschecdule弹窗状态
		switch_time: '',//ntt的reschedule传给ntt页面所需要的时间
		ntt_self_complete: false,
		is_logined: null,//header顶部条状态
		pass_date: "",//过期时间
		full_name: ''
	},
	getters: {
		_acDownloadUrl({ acDownloadUrl }) {
			if (acDownloadUrl === null) return {}

			try {
				return {
					mac: acDownloadUrl.macdata.url,
					pc: acDownloadUrl.pcdata.url
				}
			} catch (e) {
				return {
					mac: urls.acMacDownloadLink,
					pc: urls.acPcDownloadLink
				}
			}
		},

		_boardingStep({ loginStatus, per_opt }) {
			let _boardingStep = {
				doneStep: [],
				reachStep: []
			}

			let { is_login, status, exact_status } = loginStatus
			if (!is_login || status != 'onboarding' || !exact_status) return _boardingStep
			let steps = per_opt.map(item => item.step)
			let index = steps.indexOf(exact_status)
			if (index < 0) return _boardingStep
			
			return {
				doneStep: steps.slice(0, index),
				reachStep: steps.slice(0, index + 1)
			}
		}
	},
	mutations: {
		update_login_status(state, loginStatus) {
			state.loginStatus = { ...state.loginStatus, ...loginStatus }
		},
		update_ntt_self_comlete(state, r_status) {
			state.ntt_self_complete = r_status
		},
		first_enter_times(state) {
			state.first_enter++
		},
		reschedule_pop_show(state) {
			state.pop_up = !state.pop_up
		},
		update_login_state(state, login) {
			state.is_logined = login
		},
		setCookie(state, cookies) {
			var ctuskytime = new Date();
			ctuskytime.setYear(ctuskytime.getFullYear() + 1)
			console.log(ctuskytime)
			document.cookie = cookies.key + '=' + encodeURI(cookies.value) + ';expires=' + ctuskytime.toUTCString() + "; path=/; domain=.51talk.com";
		},
		delCookie(state, cookies) {
			var pasttime = new Date(new Date().getTime() - 100000);
			document.cookie = cookies.key + '= ;expires=' + pasttime.toUTCString();
		},
		getCookie(state, cookies) {
			let cookie_ary = document.cookie.split('; ')
			for (let one of cookie_ary) {
				let find = one.split('=')
				if (find[0] == cookies.name) {
					state.pass_date = find[1]
				}
			}
		},
		update_full_name(state, full_name) {
			state.full_name = full_name
		},
		updateAcDownloadUrl(state, { acDownloadUrl }) {
			state.acDownloadUrl = { ...state.acDownloadUrl, ...acDownloadUrl }
		}
	},
	actions: {
		update_switch_time({ commit, state }, time) {
			state.switch_time = time
			console.log(time)
		},
		update_ac_download_url({ commit, state }) {
			if (state.acDownloadUrl != null) return
			Vue.axios.get('/common/getAcDownloadUrl')
				.then(({ data }) => {
					const { code, res } = data
					if (data.code == 75000) {
						const { macdata, pcdata } = res
						commit('updateAcDownloadUrl', {
							acDownloadUrl: { macdata, pcdata }
						})
					} else {
						commit('updateAcDownloadUrl', {
							acDownloadUrl: {}
						})
					}
				})
				.catch(err => {
					commit('updateAcDownloadUrl', {
						acDownloadUrl: {}
					})
				})
		}
	}
})


// WEBPACK FOOTER //
// ./src/store/index.js